import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import type { RentCarSearchResponse, RentCarVehicle } from '../../../api/types/rentCar';
import { ResultCard } from '../../../components/booking/ResultCard';
import { ResultsLayout } from '../../../components/booking/ResultsLayout';
import { EmptyState } from '../../../components/common';
import { extractVehicles, vehicleDisplayName } from '../utils';

interface VehicleResultsStepProps {
  searchResult: RentCarSearchResponse;
  loading?: boolean;
  onSelect: (vehicle: RentCarVehicle) => void;
  onBackToSearch: () => void;
}

export function VehicleResultsStep({ searchResult, loading, onSelect, onBackToSearch }: VehicleResultsStepProps) {
  const vehicles = extractVehicles(searchResult.carListingSearchResponse);

  return (
    <Box>
      <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Arama Sonuçları</Typography>
        <Button onClick={onBackToSearch}>Aramaya Dön</Button>
      </Stack>

      <ResultsLayout
        isEmpty={vehicles.length === 0}
        emptyState={
          <EmptyState
            title="Bu arama için sonuç bulunamadı."
            description="Bu test hesabında RentCar için tanımlı lokasyon/sağlayıcı verisi olmayabilir (GetLocations boş liste dönüyor)."
          />
        }
      >
        {vehicles.map((vehicle, idx) => (
          <ResultCard
            key={vehicle.id ?? vehicle.code ?? idx}
            title={vehicleDisplayName(vehicle)}
            subtitle={vehicle.supplier ? `Tedarikçi: ${vehicle.supplier}` : undefined}
            attributes={
              <>
                {vehicle.category && <Chip size="small" label={vehicle.category} />}
                {vehicle.transmission && <Chip size="small" label={vehicle.transmission} />}
                {vehicle.fuelType && <Chip size="small" label={vehicle.fuelType} />}
                {vehicle.seatCount && <Chip size="small" label={`${vehicle.seatCount} koltuk`} />}
              </>
            }
            price={{ amount: vehicle.totalFare ?? vehicle.baseFare ?? null, currency: vehicle.currency }}
            primaryAction={{ onClick: () => onSelect(vehicle), disabled: loading }}
          />
        ))}
      </ResultsLayout>
    </Box>
  );
}
